import { render } from "./Videos.vue?vue&type=template&id=23ff51dd"
import script from "./Videos.vue?vue&type=script&lang=ts"
export * from "./Videos.vue?vue&type=script&lang=ts"
script.render = render

export default script